import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { ManagerMenuItems } from "Utils/Constants/ManagerMenuItems";
import Loading from "Screens/components/Loading";
import ManagerHeader from "./Components/Extra/ManagerHeader";
import { useNavigate } from "react-router-dom";
import { HandleLogOut } from "Utils/Helpers/HandleLogin";
import { read, store } from "Utils/Helpers/LocalStorage";
import { HandleLoading } from "Utils/Helpers/ApiServices";

export default function Manager() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("home");
  const { isLogin } = useSelector((state) => ({
    isLogin: state.user.isLogin,
  }));

  useEffect(() => {
    dispatch(HandleLoading(false));
    if (!isLogin) {
      navigate("/");
      dispatch(HandleLogOut(navigate));
    } else {
      const lamt = read("amt");
      if (lamt) setSelected(lamt);
    }
  }, [isLogin]);

  const handleChange = (event, newValue) => {
    store("amt", newValue);
    setSelected(newValue);
  };

  return (
    <div className="a-container">
      {isLogin && (
        <>
          <Loading />
          <ManagerHeader />
          <TabContext value={selected}>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              className="a-menu"
            >
              {ManagerMenuItems.map((items, index) => {
                return (
                  <Tab
                    key={`MainTab-${index + 1}`}
                    icon={items.icon}
                    label={<span>{items.title}</span>}
                    value={items.value}
                  />
                );
              })}
            </TabList>
            <div className="a-body">
              {
                ManagerMenuItems.find((item) => item.value === selected)
                  .bodyContainer
              }
            </div>
          </TabContext>
        </>
      )}
    </div>
  );
}
